var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bkf-icon',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({attrs:{"color":_vm.color}},'v-icon',attrs,false),on),[_vm._v("\n        "+_vm._s(_vm.icon)+"\n      ")])]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.text))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }